import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import VueSweetalert2 from 'vue-sweetalert2';

Vue.config.productionTip = false

//axios
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

//toastr
import VueToastr2 from 'vue-toastr-2'
import 'vue-toastr-2/dist/vue-toastr-2.min.css'
window.toastr = require('toastr')
Vue.use(VueToastr2)

//Sweetalert
Vue.use(VueSweetalert2);

//jquery
window.$ = window.jQuery = require("jquery");

//moment
Vue.use(require('vue-moment'));

//funciones globales
import {funciones} from "./patrones/funciones";
Vue.prototype.$funciones = funciones;

//token global, errores axiso globales
if(store.getters.isLogin)
  axios.defaults.headers.common.Authorization  = "Bearer " + store.state.token;

axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if(error.response.status === 403 || error.response.status === 404){
    router.push({name:'error'});
  }
  if(error.response.status === 401) //si no esta autenticado o no existe tocken)
  {
    toastr.error("Se ha cerrado sesión desde otra máquina, o su tiempo de inactividad a caducado. Vuelva a ingresar al sistema");
    store.dispatch("destroyToken").then(response => {
      router.push({name:'login'});
    }).catch(e => {
      toastr.warning("Se ha cerrado sesión con algún error, le recomendamos que ingrese al sistema y cierre sesión para solucionar los problemas");
      router.push({name:'login'});
    })
  }
  return Promise.reject(error);
});
//end token global y errores

//usuario actual
if(store.getters.isLogin) {
  store.dispatch("getUsuario");
  store.dispatch("getSistemas");
}

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
